import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ticket, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const Box = ({ icon: I, title, text, placeholder, onGo, testid }) => {
  const [v, setV] = useState("");
  return (
    <form onSubmit={(e) => { e.preventDefault(); v.trim() && onGo(v.trim().toUpperCase()); }} className="card-soft p-6">
      <I className="h-7 w-7 text-[#0052FF]" />
      <div className="mt-3 font-display text-xl font-extrabold">{title}</div>
      <p className="text-sm text-slate-500">{text}</p>
      <Input value={v} onChange={(e) => setV(e.target.value)} placeholder={placeholder} className="mt-4 h-11 font-mono font-bold uppercase" data-testid={`${testid}-input`} />
      <Button type="submit" className="mt-3 h-11 w-full rounded-xl bg-[#0052FF] font-bold hover:bg-[#0041CC] btn-press" data-testid={`${testid}-button`}>Continue</Button>
    </form>
  );
};

export default function FindTicket() {
  const nav = useNavigate();
  return (
    <div className="hero-bg min-h-full">
      <div className="mx-auto grid max-w-3xl gap-4 px-4 py-10 sm:grid-cols-2 sm:px-6">
        <Box icon={Ticket} title="Find my ticket" text="View, print or resend your ticket by SMS." placeholder="Booking code e.g. GPAB12CD" testid="find-ticket" onGo={(c) => nav(`/ticket/${c.split("-")[0]}`)} />
        <Box icon={ShieldCheck} title="Verify a ticket" text="Check a ticket is genuine (same as scanning its QR)." placeholder="Ticket no. e.g. GPAB12CD-05" testid="verify-ticket" onGo={(c) => nav(`/verify/${c}`)} />
      </div>
    </div>
  );
}
